export default [
    {
        path: 'information',
        name: 'information',
        component: () => import(/* webpackChunkName: "combind" */'@/views/main/user/Information.vue'),
        meta: {
            title: 'information',
            icon: 'icon-avator',
        },
    },
];
